import {Pipe, PipeTransform} from '@angular/core';
import {MathUtils, Utils} from '@astek/utils';

@Pipe({
  name: 'xpToFixedStep',
})
export class ToFixedStepPipe implements PipeTransform {

  constructor(
  ) {
  }

  public transform(
    value: number | null | undefined,
    step: number,
    positivePrefix: string = '',
    zeroPrefix: string = '',
    negativePrefix: string = '-',
  ): string {
    if (Utils.isNullOrUndefined(value)) {
      return '--';
    }
    return MathUtils.toFixedStep(
      value,
      step,
      positivePrefix,
      zeroPrefix,
      negativePrefix,
    );
  }

}
